webpackJsonp([10991734084388],{

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(17);
	
	var _Layout = __webpack_require__(64);
	
	var _Layout2 = _interopRequireDefault(_Layout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import {About} from '../../components';
	
	
	// export default About;
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _Layout2.default,
	    null,
	    _react2.default.createElement(_components.PageTitle, { title: '\u516C\u53F8\u7B80\u4ECB' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-index-js-a0667992edca793420bd.js